import { BinaryTree } from './binary-tree';
import { CoordinatorService } from './coordinator.service';
import { ScriptTags } from './script-tags';

export class ScriptRatings extends ScriptTags {
    constructor(coords: CoordinatorService, _bt: BinaryTree) {
        super(coords, _bt);
    }
}
